module.exports = __webpack_public_path__ + "static/media/moon.ec6b2954.jpg";